import React, { useEffect } from "react";
import IconButton from "@material-ui/core/IconButton";
import { RemoveCircleOutlineMaterialIcon } from "Icons/MaterialIcons";
import InputFormComponent from "components/UI/InputFormComponent/InputFormComponent";

const DynamicInputForm = ({
	inputFields,
	inputField,
	placeholder,
	setInputField,
	setValidate,
	inputType,
	inputName,
	disabled
}) => {
	useEffect(() => {
		if (inputField === "" || inputField.length === 0) {
			setValidate(false);
		} else {
			setValidate(true);
		}
	}, []);

	const handleChangeInput = (id, event) => {
		event.preventDefault();
		const value = event.target.value;
		const newInputFields = inputFields.map((i) => {
			if (id === i[0]) {
				if (value === "") {
					i = [id, value, false];
				} else {
					i = [id, value, true];
				}
			}
			return i;
		});
		setInputField(newInputFields);
	};

	const handleRemoveFields = (id) => {
		const values = [...inputFields];
		values.splice(
			values.findIndex((value) => value[0] === id),
			1
		);
		setInputField(values);
	};

	return (
		<>
			<InputFormComponent
				className="form__input"
				type={inputType}
				name={inputName}
				autoFocus={true}
				placeholder={placeholder}
				disabled={disabled}
				value={inputField[1]}
				onChange={(event) => handleChangeInput(inputField[0], event)}
			/>
			<IconButton
				disabled={inputFields.length === 1}
				onClick={() => handleRemoveFields(inputField[0])}
			>
				<RemoveCircleOutlineMaterialIcon
					className={
						inputFields.length === 1
							? "form__removeIcon--disabled"
							: "form__removeIcon"
					}
				/>
			</IconButton>
		</>
	);
};

export default DynamicInputForm;
